//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import footerNav from '@/components/footer/footer'
    import api from '@/api/index'
    import { Indicator } from 'mint-ui'
    export default {
        components: {
            footerNav
        },
        name: "class",
        data(){
            return{
                cur:0,
                //课程分类
                classlist:[
                    {classname:"全部"},

                ],
                //课程内容
                classconlist:[

                ],
                coursetype:'',
                logined: false,
                continueCourse:{
                    coverpath:"",
                    title:"标题",
                    nextLength:"0分0秒",//剩余时长
                    lessonDuration:"0分0秒",//总时长
                    lessonCount:0,//总课时数
                    record:0,//进度百分比
                    courseId:1//课程编号
                }
            }
        },
        created() {
            this.cur=parseInt(this.$route.query.cur)+1
            console.log(this.cur);
            this.coursetype=this.$route.query.coursetype

        },
        mounted() {
            this.getclasslist(this.coursetype);
            this.getCourseTypeList();
        },

        methods:{
            getCourseTypeList(){
                // 获取首页数据(轮播图
                api.getCourseTypeList({
                    params: {
                    }
                }).then(resp => {
                    let courseTypeList = resp.data;
                    for (let i = 0; i < courseTypeList.length; i++) {
                        this.classlist.push({classname:courseTypeList[i].courseTypeName,coursetype:courseTypeList[i].courseType});
                    }
                }).catch((resp) => {
                    console.log(resp);
                })
            },
            //切换
            gonext(id){
                this.$router.push({
                    path: '/index/courseInfo',
                    query:{
                        courseid:id
                    }
                });
            },
            getclass(index,coursetype){
                this.coursetype = coursetype
                this.cur = index
                this.getclasslist(5,coursetype);
                if (coursetype =='' || coursetype ==null ){
                    return this.getclasslist();
                }
            },
            routerToDetail(courseid) {
                this.$router.push({
                    path: '/index/courseInfo',
                    query: {
                        courseid: courseid
                    }
                })
            },
            getclasslist(coursetype){
                Indicator.open({
                    text: '加载中...',
                    spinnerType: 'fading-circle'
                });
                var coursetype = this.coursetype;
                // 获取首页数据(轮播图
                api.getIndex({
                    params: {
                        pagesize: '',
                        coursetype:coursetype,
                        yumingHost:window.location.host
                    }
                }).then(resp => {
                    let courselist = resp.result.courselist;
                    this.classconlist = [];
                    for(let index in courselist){
                        let min = Math.floor(courselist[index].mediaDuration/1000/60);
                        let sen = Math.floor(courselist[index].mediaDuration/1000-min*60);
                        let courseobj = {
                            courseid:courselist[index].courseid,
                            //conpic:require('../../assets/images/poster1.jpg'),
                            conpic:courselist[index].iconurl+"?x-oss-process=image/resize,m_fill,w_220,h_156",
                            contitle:courselist[index].title,
                            classnum:courselist[index].duration,
                            classtime:min+'分'+sen+'秒',
                            price:'',
                            //userpic:require(courseList[index].iconurl),
                            userpic:courselist[index].iconurl+"?x-oss-process=image/resize,m_fill,w_220,h_156",
                            username:courselist[index].teacher.length>8?courselist[index].teacher.substr(0,8)+"...":courselist[index].teacher,
                            //username:courselist[index].teacher,
                            usernum:courselist[index].studyCount
                        };
                        this.classconlist.push(courseobj);
                    }
                }).catch((resp) => {
                })
            }
        }
    }



// WEBPACK FOOTER //
// ./src/view/class/class.vue